import { ReactElement } from 'react';
import { GlobalModal, GlobalModalProps } from '../GlobalModal/GlobalModal';


export const CabinetModal = (props: GlobalModalProps): ReactElement => {
  return (
    <GlobalModal  {...props} />
  );
};